var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoEmployeesIcon = function SvgNoEmployeesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 142,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M194.74 67.355c0 49.143-39.404 100.915-92.271 57.155C49.603 80.75.262 116.498.262 67.355c0-49.142 42.582-64.206 79.444-36.783C116.566 57.995 194.74 18.213 194.74 67.355Z",
    fill: props.accentFill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.04 20.257c1.147-.52 2.532-.232 3.327.69L74.06 38h46.883l14.693-17.053c.794-.922 2.18-1.21 3.327-.69l27.099 12.273c.785.356 1.336 1.038 1.48 1.833.143.795-.138 1.605-.757 2.176L142.59 58.86v60.64c0 1.381-1.216 2.5-2.716 2.5H55.129c-1.5 0-2.716-1.119-2.716-2.5V58.86L28.217 36.54c-.618-.57-.9-1.38-.756-2.176.143-.795.694-1.477 1.48-1.833l27.098-12.273ZM57.844 60v57h79.312V60H57.845Zm82.435-6.088 19.983-18.436-21.732-9.842-12.451 14.45 14.2 13.828ZM133.499 55l-12.52-12H74.024l-12.52 12h71.995ZM68.922 40.084l-12.45-14.45-21.733 9.842 19.983 18.436 14.2-13.828Z",
    fill: "#363840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.162 82.337c1.886 0 3.415-1.419 3.415-3.169S87.048 76 85.162 76c-1.887 0-3.416 1.418-3.416 3.168 0 1.75 1.53 3.169 3.416 3.169ZM119.804 82.337c1.887 0 3.416-1.419 3.416-3.169S121.691 76 119.804 76c-1.886 0-3.415 1.418-3.415 3.168 0 1.75 1.529 3.169 3.415 3.169Z",
    fill: "#363840"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.044,
    cy: 93,
    rx: 5.432,
    ry: 4,
    stroke: "#363840",
    strokeWidth: 4
  })));
};
export default SvgNoEmployeesIcon;